import type { ThemeProps as Props } from "models/styles/theme";
import styled from "styled-components/macro";

import { ListNavigationItem } from "components/ListNavigationItem/ListNavigationItem";
import { CssFlex } from "styles/helpers/layout";

import { StyledImmersiveReaderButton } from "components/ImmersiveReaderButton/ImmersiveReaderButton.styled";

export const StyledCard = styled.div`
  width: 100%;
  margin-bottom: 40px;
  border-radius: 1rem;
  background: ${(props: Props) => props.theme.palette.neutral.white};
  border: solid 1px ${(props: Props) => props.theme.palette.neutral._900};
`;

export const StyledHeader = styled(CssFlex)`
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 1rem 1rem 0 0;
  font-size: ${(props: Props) => props.theme.font.size._16};
  font-weight: ${(props: Props) => props.theme.font.weight.bold};
  color: ${(props: Props) => props.theme.palette.secondary.brand};
  background-color: ${(props: Props) => props.theme.palette.secondary._900};

  ${StyledImmersiveReaderButton} {
    padding: 0;
    height: 1.5rem;
    width: 1.5rem;

    svg {
      max-width: 100%;
      max-height: 100%;
    }
  }

  h3 {
    margin: unset;
  }
`;

export const StyledTopicListItem = styled(ListNavigationItem)`
  border: none;

  :not(:first-child) {
    border-top: solid 1px ${(props: Props) => props.theme.palette.neutral._900};
  }

  :last-child {
    border-radius: 0 0 1rem 1rem;
  }

  :hover {
    background: ${(props: Props) => props.theme.palette.secondary._950};
  }

  h3 {
    letter-spacing: 0;
    font-size: ${(props: Props) => props.theme.font.size._16};
    font-weight: ${(props: Props) => props.theme.font.weight.normal};
  }

  svg {
    fill: ${(props: Props) => props.theme.palette.primary.brand};
  }
`;
